import Icon from '../components/Icon.vue'

Icon.register({"dove":{"width":512,"height":512,"paths":[{"d":"M288 167.2V139.1C259.8 102.8 240.9 59.8 233.9 13.9 231.8 0.4 214.9-4.9 206.1 5.6 185 30.5 168.4 59.7 157.2 92.1 191.4 130.4 237.2 156.7 288 167.2zM400 64C355.8 64 320 99.9 320 144.1V203.5C215.6 197.3 127 133 87 41.8 81.5 29.3 63.8 28.6 58 40.9 41.4 76 32 115.2 32 156.6 32 227.4 66.1 293.5 117.1 342.5 130.3 355.2 143.2 365.7 156 375.3L12.1 411.3C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512 163.8 512.3 171.8 509.4 177.9 504.1L243.1 448H320C408.4 448 480 376.5 480 288.1V128L512 64H400zM400 160.1C391.2 160.1 384 152.9 384 144.1S391.2 128.1 400 128.1 416 135.3 416 144.1 408.8 160.1 400 160.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/dove.js
// module id = null
// module chunks = 